import { render, staticRenderFns } from "./group_token.vue?vue&type=template&id=45b4ccff&vue3"
import script from "./group_token.vue?vue&type=script&lang=js&vue3"
export * from "./group_token.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports